module.exports = __webpack_public_path__ + "static/media/travelclick.cf4bd16e.png";